const SearchIcon = (props) => (
  <svg
    width={31}
    height={31}
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M30 30L21.6275 21.6275M21.6275 21.6275C23.8142 19.4409 25.1667 16.4201 25.1667 13.0833C25.1667 6.40989 19.7568 1 13.0833 1C6.40989 1 1 6.40989 1 13.0833C1 19.7568 6.40989 25.1667 13.0833 25.1667C16.4201 25.1667 19.4409 23.8142 21.6275 21.6275Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SearchIcon;
